<template>
  <div class="content">
    <div class="background-index">
      <div class="top-title common">
        查询服务窗口
      </div>
      <div class="middle-title common">
        Progress Tracking
      </div>
      <div class="bottom-operator common">
        <div @click="pushRouter('/query?linkname=我要查询')">
          <img src="../../../assets/images/icon_jump_business_guide.png">
          <div>
            <p>日本签证</p>
            <p>Japan Visas</p>
          </div>
        </div>
        <div @click="open('https://consular.mfa.gov.cn/VERIFY/#/hcRzYyAdSgcx')">
          <img src="../../../assets/images/icon_jump_window_business.png">
          <div>
            <p>领事认证</p>
            <p>Consular Authentication</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'business-lobby',
  methods: {
    open (url) {
      window.open(url)
    },

  },
  created () {
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  height: 637px;
}
.background-index {
  height: 637px;
  width: 100%;
  position: absolute;
  z-index: 1;
  background-image: url("../../../assets/pic4.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.top-title {
  width: 574px;
  height: 65px;
  font-size: 68px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
  top: 139px;
}
.middle-title {
  width: 736px;
  height: 31px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  top: 221px;
}
.bottom-operator {
  width: 834px;
  height: 100px;
  display: flex;
  top: 442px;
  > div:last-of-type {
    margin-left: 17px;
  }
  > div:first-of-type {
    margin-right: 17px;
  }
  > div {
    cursor: pointer;
    background: #fff;
    width: 400px;
    height: 100px;
    text-align: left;
    img {
      width: 64px;
      height: 64px;
      margin: 0 32px 0 61px;
    }
    > div {
      display: inline-block;
      transform: translateY(40%);
      > p {
        margin: 0;
        padding: 0;
      }
      > p:first-of-type {
        height: 26px;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3a3a3a;
        text-align: center;
      }
      > p:last-of-type {
        height: 13px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3a3a3a;
        margin-top: 9px;
        text-align: center;
      }
    }
  }
}
.common {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/content/searchService/index.vue